import * as React from "react"
import {Box} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";


export default function referenceDiscountColumn(name, label) {
	return {
		name, label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value) => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				{formatPercentage(value)}
			</Box>
		}
	}
}